import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { usePortalLocale } from '@/lib/i18n/PortalLocaleContext';
import { createMembershipDemo } from './membership-demo';
import { MembershipWorkspace } from './MembershipPage';
export function MembershipDemoPage() {
  const { t } = usePortalLocale();
  const [session, setSession] = useState(() => ({
    id: 0,
    client: createMembershipDemo(),
    queries: new QueryClient({ defaultOptions: { queries: { retry: false } } }),
  }));
  return (
    <QueryClientProvider client={session.queries}>
      <main className="mx-auto max-w-6xl space-y-5 px-4 py-6">
        <aside
          className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-hairline bg-surface p-4 text-sm"
          role="note"
        >
          <div>
            <strong>{t('Demo · fictional Harper family / Mia, age 10')}</strong>
            <p className="mt-1">
              {t(
                'Pre-generated result · simulated Plus membership and billing · snapshot 21 Oct 2026 · changes stay in this session.',
              )}
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <button
              className="btn-pill-secondary"
              onClick={() => {
                session.queries.clear();
                setSession({
                  id: session.id + 1,
                  client: createMembershipDemo(),
                  queries: new QueryClient({ defaultOptions: { queries: { retry: false } } }),
                });
              }}
            >
              {t('Reset this Demo')}
            </button>
            <Link className="btn-pill-ghost" to="/membership">
              {t('Exit Demo')}
            </Link>
          </div>
        </aside>
        <MembershipWorkspace
          key={session.id}
          familyId="fictional-harper"
          client={session.client}
          demo
        />
      </main>
    </QueryClientProvider>
  );
}
